"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.errorReducer = exports.endReducer = exports.startReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _m = require("@mutant-ws/m");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var debug = require("debug")("ReduxList:UpdateReducers");

var startReducer = function startReducer(state, _ref) {
  var id = _ref.id,
      data = _ref.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    updating: [{
      id: id,
      data: data
    }]
  });
};

exports.startReducer = startReducer;

var endReducer = function endReducer(state, _ref2) {
  var item = _ref2.item,
      onMerge = _ref2.onMerge,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? _m.i : _ref2$onChange;
  return _objectSpread(_objectSpread({}, state), {}, {
    items: onChange((0, _m.intersect)(function (a, b) {
      return a.id === b.id;
    }, (0, _m.is)(onMerge) ? onMerge : function (a, b) {
      return _objectSpread(_objectSpread({}, a), b);
    })(state.items, [item])),
    // reset error after successfull action
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      update: null
    }),
    updating: []
  });
};

exports.endReducer = endReducer;

var errorReducer = function errorReducer(state, error) {
  return _objectSpread(_objectSpread({}, state), {}, {
    updating: [],
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      update: error
    })
  });
};

exports.errorReducer = errorReducer;